module.exports = __webpack_public_path__ + "static/media/arrow_up.7d5b0f85.svg";